<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card elevation="6">
        <div class="pa-2">
          <v-card-title>
            <v-text-field color="#86bc3a" v-model="search" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="datalist" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
            <template v-slot:item="dataDetail">
              <tr>
                <td>{{ dataDetail.item.doc_no }}</td>
                <td>{{ dataDetail.item.supplier_name }}</td>
                <td>{{ diffDateTH(dataDetail.item.return_date) }}</td>
                <td>{{ dataDetail.item.total }}</td>
                <td>{{ dataDetail.item.note_issue }}</td>
                <td>
                  <div v-if="dataDetail.item.status === null">ไม่พบข้อมูล</div>
                  <div v-if="dataDetail.item.status === 3" style="color: #3fb455">เสร็จสิ้น</div>
                </td>
                <td>{{ dataDetail.item.doc_from_supplier }}</td>
                <td class="pa-3">
                  <v-btn small height="42" @click="getDetails(dataDetail.item.doc_no)" class="grad-success-bg white--text mr-1 mb-1" title="ดูรายละเอียด">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Document_reduce_debt",
  data() {
    return {
      loading_page: false,
      search: '',
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [
        {
          text: 'เลขที่เอกสาร',
          value: 'doc_no',
          fixed: true,
          width: '120px',
        },
        {
          text: 'บริษัท',
          value: 'supplier_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'วันที่ส่งคืน',
          value: 'return_date',
          fixed: true,
          width: '170px',
        },
        {
          text: 'ยอดชำระ',
          value: 'total',
          fixed: true,
          width: '100px',
        },
        {
          text: 'วิธีการแก้ไข',
          value: 'note_issue',
          fixed: true,
          width: '170px',
        },
        {
          text: 'สถานะ',
          value: 'status',
          sortable: false,
          fixed: true,
          width: '80px',
        },
        {
          text: 'การตอบรับ',
          value: 'doc_from_supplier',
          fixed: true,
          width: '230px',
        },
        {
          text: 'จัดการ',
          value: 'action',
          sortable: false,
          fixed: true,
          width: '100px',
        },

      ],
      datalist: [],
    }
  },
  methods: {
    diffDateTH(value) {
      if (value !== null) {
        const diff = value.split('-')
        const day = diff[2]
        const month = diff[1]
        const year = parseInt(diff[0])+ 543
        return day+'/'+month+'/'+year
      }
      else {
        value = ''
        return value
      }
    },
    getDetails(id) {
      this.$router.push('/stock/document/documentreducedetails/' + id)
    },
    get_all() {
      this.loading_page = true
      HTTP.post('/returnproductdocs/allsuccess')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.datalist = res.data.object
              for (let index = 0; index < this.datalist.length; index++) {
                if (this.datalist[index].issue_select == 0) {
                    this.datalist[index].note_issue = 'ทำใบ C/N.'
                }
                if (this.datalist[index].issue_select == 1) {
                    this.datalist[index].note_issue = 'คืนเป็นสินค้าเดิม'
                }
                if (this.datalist[index].issue_select == 2) {
                    this.datalist[index].note_issue = 'คืนเป็นสินค้าใหม่'
                }
                if (this.datalist[index].issue_select == 3) {
                    this.datalist[index].note_issue = 'คืนไปเลยเพราะส่งผิด'
                }
              }
            }
          })
    },
  },
  mounted() {
    this.get_all()
  }
}
</script>

<style scoped>

</style>
